import ApiService from "./api.service";

class InterpellationService extends ApiService {
    getAllInterpelattions(page) {
        return this.get(`api/meeting/interpellation/getAllInterpellations/${page}`)
    }
    searchInterpellation(data) {
        return this.post(`api/meeting/interpellation/search`, data);
    }
    deleteInterpelation(id) {
        return this.delete(`api/meeting/interpellation/${id}`)
    }
    updateInterpellation(data) {
        return this.post(`api/meeting/interpellation/${data.id}`, data)
    }
    addInterpellation(data) {
        return this.post(`api/meeting/interpellation`, data)
    }
    addInterpellationAttachement(data) {
        return this.post(`api/meeting/interpellation/addInterpellationAttachement`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    }
    deleteFile(intId, fileId) {
        return this.delete(`api/meeting/interpellation/deleteFile/${intId}/${fileId}`)
    }
    downloadAttachment(intId, fileId) {
        return this.get(`api/meeting/interpellation/downloadAttachment/${intId}/${fileId}`, { responseType: "arraybuffer" })
    }
    getInterpellationResponses(data) {
        return this.put(`api/meeting/interpellation/${data.id}/responses`, data)
    }
    deleteInterpelationResponse(interpellationId, id) {
        return this.delete(`api/meeting/interpellation/${interpellationId}/responses/${id}`)
    }
    addInterpellationResponse(data) {
        return this.post(`api/meeting/interpellation/${data.id}/responses`, data);
    }
    getUsersForInterpelattions() {
        return this.get(`api/meeting/interpellation/getUsersForInterpelattions`);
    }
    getNewInterpelationsCount() {
        return this.get(`api/meeting/interpellation/getNewInterpelationsCount`);
    }
}

export default new InterpellationService();